module.exports = __webpack_public_path__ + "media/images/banner/discovery_mobile-84029bcf67cddcd1271911a14c75551a.png";